import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { AuthProvider } from "./lib/api/auth";
import { FamilyDataProvider } from "./lib/context/FamilyDataContext";
import { CountdownProvider } from "./lib/context/CountdownContext";
import i18n from "./i18n";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <FamilyDataProvider>
          <CountdownProvider>
            <BrowserRouter basename={__BASE_PATH__}>
              <AppRoutes />
            </BrowserRouter>
          </CountdownProvider>
        </FamilyDataProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
